<template>
  <fieldset class="custom-fieldset">
    <legend>Odcinek nr {{ partIndex + 1 }}</legend>
    <v-row>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Przewoźnik*" v-model="contextPart.carrier" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field label="Numer lotu" v-model="part.flight_number" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="baggageRules"
          label="Bagaż rejestrowany"
          v-model="contextPart.baggage"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Termin wylotu*"
          v-model="contextPart.start_date"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Termin lądowania*"
          v-model="contextPart.end_date"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Klasa*" v-model="contextPart.seat_class" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Skąd*" v-model="contextPart.from" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Dokąd*" v-model="contextPart.to" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" v-if="showReturnCheckbox" cols="12">
        <v-checkbox
          :rules="returnRouteCheckboxRules"
          @click.native="$emit('returnRouteCheckboxReValidate')"
          label="Trasa powrotna"
          ref="checkboxReturnRoute"
          v-model="contextPart.is_return_route"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>

      <v-col class="pa-1" cols="12">
        <v-textarea label="Komentarz" v-model="contextPart.comment" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
    </v-row>
  </fieldset>
</template>

<script>
export default {
  name: "FlightForm",
  props: {
    part: {
      required: true
    },
    partIndex: {
      required: true,
      type: Number
    },
    returnRouteCheckboxRules: {
      required: true,
      type: Array
    },
    baggageRules: {
      required: true,
      type: Array
    },
    showReturnCheckbox: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    contextPart: {
      get() {
        return this.part;
      },
      set(val) {
        this.$emit("update:part", val);
      }
    }
  },
  methods: {
    isRequired(v) {
      return (v != null && v.length > 0) || "Pole wymagane";
    },
    reValidateCheckbox() {
      this.$refs.checkboxReturnRoute.validate();
    }
  }
};
</script>

<style scoped></style>
